module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("FOREWORD")])]), _c('p', {
    staticClass: "auteur"
  }, [_vm._v("Dennis Edwards")]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Adam Gustine has done the church in the United States a great service. "), _c('i', [_vm._v("Becoming a Just Church")]), _vm._v(" is one of those rare books possessing the potential to change the way we think about and do Christian ministry. We need to hear what Dr. Gustine has to say because there are way too many “here’s how you can have a church like mine” sort of books, written by charming leaders who managed to grow large churches but who try to quantify and perhaps even commodify the grace of God through their books.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I’ve twice been a church planter (Brooklyn, NY, and Washington, DC) and twice been called to serve established churches (Washington, DC, and Minneapolis, MN). Along my journey of over thirty years in urban ministry, I’ve become acquainted with books that typically tell the stories of a church’s (or a pastor’s) success—usually defined as large numbers of people attending weekend worship services. Rarely have I encountered books to help Christians understand that the practice of God’s justice is part of Christian discipleship and not merely some program added onto an already overloaded schedule. "), _c('i', [_vm._v("Becoming a Just Church ")]), _vm._v("offers a way "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("of thinking for newly planted churches as well as established churches in a variety of settings (i.e., urban, suburban, rural). While Gustine’s principles are certainly biblical, they are not merely theoretical; they mirror genuine pastoral realities.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I think that many pastors can relate to people getting fired up over an issue in the news and wondering what the church (or the pastor) will do about it. We find that our passion for justice comes in waves or flares up, depending on the news cycle. Yet God calls his people—in both Testaments of Scripture—to do justly, love mercy, and walk humbly with God. Passion for justice does not have its provenance in any particular political ideology, although it can often feel that way in our polarized society. The Great Commandment—to wholeheartedly love the Lord and love our neighbors—provides the drive for Christian commitment to justice, not the Democratic or Republican parties of the United States.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Becoming a Just Church")]), _vm._v(" provides both a theological framework as well as practical guidance on how followers of Jesus can live out the Great Commandment.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0